import { render, staticRenderFns } from "./ResetPwdView.vue?vue&type=template&id=1ed6ba3a&scoped=true&"
import script from "./ResetPwdView.vue?vue&type=script&lang=js&"
export * from "./ResetPwdView.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdView.vue?vue&type=style&index=0&id=1ed6ba3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6ba3a",
  null
  
)

export default component.exports